
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState, "note" | "setNote"> & { dialog: Extract<NonNullable<PurchaseOrdersViewState["dialog"]>, { kind: "cancel"; }>; };

export function PurchaseOrderCancelFields({ dialog, note, setNote }: Props) {
  return (<>
    <>
      <div className="purchase-order-decision">
        <span>{dialog.order.orderNo}</span>
        <strong>{dialog.order.supplierName}</strong>
        <p>
          İptal işlemi gerekçesiyle birlikte performans ve denetim
          kaydına yazılır.
        </p>
      </div>
      <label>
        İptal gerekçesi
        <textarea
          rows={4}
          value={note}
          onChange={(event) => setNote(event.target.value)}
          placeholder="En az 5 karakterle gerekçeyi yazın"
        />
      </label>
    </>
  </>);
}
